import { buildUrl } from "./auth";

export const trackPageVisit = async ({ sessionId, path, referrer }) => {
  try {
    await fetch(buildUrl("/api/attendance/visit"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        sessionId,
        path,
        referrer: referrer || null,
      }),
    });
  } catch {
    // Non-blocking by design.
  }
};

const attendanceApi = { trackPageVisit };

export default attendanceApi;
